import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

class ElementLink extends Component {
  handleClick = () => {
    const { history, to } = this.props;
    history.push(to);
  };

  render() {
    const {
      element: Element,
      children,
      className,
      style,
      elementRef,
    } = this.props;

    return (
      <Element
        onClick={this.handleClick}
        className={className}
        style={style}
        ref={elementRef}
      >
        {children}
      </Element>
    );
  }
}

export default withRouter(ElementLink);
